import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { countriesSlice, Country } from "./countries.slice";

const reducerActions = countriesSlice.actions;

let config = {
  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*',
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Credentials": true,
  }
};

export enum CountriesAction {
  FETCH_COUNTRIES = "countries/fetchCountries",
}

export const fetchCountries = createAsyncThunk(
  CountriesAction.FETCH_COUNTRIES,
  async (_, thunkAPI) => {
    const response = await axios.get("/api/common/countries?subset=Subset-Country-Onboarding-SignupAllowed-NA", config).then(res => res.data);
    if (response.state === "ERROR" && response.result) {
      const error = response.result;
      return thunkAPI.rejectWithValue(error.description || error.message || "Fetch countries failed");
    }
    return response as Country[];
  }
);

export const countriesActions = {
  fetchCountries,
  ...reducerActions,
};
